module.exports = __webpack_public_path__ + "static/media/logo-kango-1.9b652bf9.jpg";